import { render } from "./Camera2.vue?vue&type=template&id=a0dff40c"
import script from "./Camera2.vue?vue&type=script&lang=js"
export * from "./Camera2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__